import { apiRequest, getResource } from "../api/http";

// All the payments (donations, subscriptions, exclusive content), thanks and
// gifts. "transactions" section: view to read, edit to thank and give.
const BASE = "/api/admin/payments";
const EMPTY_PAGE = { items: [], total: 0, page: 1, pageSize: 25 };

const query = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "");
  return entries.length ? `?${new URLSearchParams(entries).toString()}` : "";
};

export const getPayments = (params) => getResource(`${BASE}${query(params)}`, { fallback: EMPTY_PAGE });
export const getPaymentsStats = (params) => getResource(`${BASE}/stats${query(params)}`, { fallback: null });
/** Evolution per day or week, per type, method and status (every status, page filters). */
/** Rejects on failure, so the chart can say why. */
export const getPaymentsChart = (params) => getResource(`${BASE}/chart${query(params)}`, { rethrow: true });
export const getPaymentDetail = (id) => getResource(`${BASE}/${id}`, { rethrow: true });

/** Exact email that would be sent (nothing is sent). Rejects with the API message. */
export const previewThanks = (id, options) =>
  apiRequest("post", `${BASE}/${id}/thanks/preview`, { data: options, rethrow: true });

/** Thanks one payment or a selection: resolves with { sent, skipped, failed }. */
export const sendThanks = (ids, options) =>
  ids.length === 1
    ? apiRequest("post", `${BASE}/${ids[0]}/thanks`, { data: options, rethrow: true })
    : apiRequest("post", `${BASE}/thanks`, { data: { ...options, ids }, rethrow: true });

/** Days of subscription offered to the payer (account needed). */
export const giveGift = (id, days) => apiRequest("post", `${BASE}/${id}/gift`, { data: { days }, rethrow: true });

/** Refunds a payment: { amount, reason, note, endSubscription, manual, password }. Rejects with the API message. */
export const refundPayment = (id, options) => apiRequest("post", `${BASE}/${id}/refund`, { data: options, rethrow: true });

export const apiError = (error) => error?.response?.data?.message || "";
